import { z } from 'zod';

// スタジオ（問題管理アプリ）の入力と出力。docs/studio.md

const email = z.string().trim().toLowerCase().email('メールアドレスの形が正しくありません').max(254);
const password = z.string().min(10, 'パスワードは10文字以上にしてください').max(200);
const totp = z.string().trim().regex(/^\d{6}$/, '認証アプリの6桁のコードを入れてください');

export const StudioRoleSchema = z.enum(['admin', 'approver']);
export type StudioRoleName = z.infer<typeof StudioRoleSchema>;
export const STUDIO_ROLE_LABEL: Record<StudioRoleName, string> = { admin: '管理者', approver: '承認者' };

export const StudioLoginBody = z.object({ email, password: z.string().min(1).max(200), totp });
export const StudioInviteBody = z.object({ email, role: StudioRoleSchema });
export const StudioInviteStartBody = z.object({ displayName: z.string().trim().min(1, '名前を入れてください').max(40), password });
export const StudioInviteConfirmBody = z.object({ code: totp });
/** 自分のアカウント（設定の画面）：名前・パスワードの変更 */
export const StudioMePatchBody = z.object({ displayName: z.string().trim().min(1, '名前を入れてください').max(40).optional(), currentPassword: z.string().max(200).optional(), password: password.optional() });
export const StudioMemberPatchBody = z.object({ role: StudioRoleSchema.optional(), disabled: z.boolean().optional() });

export const StudioMemberSchema = z.object({
  id: z.string(),
  email: z.string(),
  displayName: z.string(),
  role: StudioRoleSchema,
  disabled: z.boolean(),
  lastLoginAt: z.string().nullable(),
  /** パスワード・2段階認証の再設定待ち（メールのリンクから登録し直すまでログインできない） */
  pending: z.boolean().optional(),
  createdAt: z.string().optional(),
});
export type StudioMember = z.infer<typeof StudioMemberSchema>;
